import { PrivateRouteCMS } from "@/navigation/PrivateRouteCMS";
import { useAuth } from "@/context/auth/AuthContext";
import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactNode;
}

/**
 * Garde du CMS avancé : exige que l'instance ait le CMS avancé activé
 * (`CMS.advancedCmsEnabled`), EN PLUS de l'auth CMS. Sinon → retour sur l'ancien
 * CMS (/cms). Accès direct par URL impossible tant que le mode n'est pas activé.
 */
export const PrivateRouteCMSAdvanced = ({ children }: PrivateRouteProps) => {
  const { instanceData } = useAuth();

  // Redirige seulement une fois l'instance chargée et le mode désactivé.
  if (instanceData && !instanceData.CMS?.advancedCmsEnabled) {
    return <Navigate to="/cms" replace />;
  }

  return <PrivateRouteCMS>{children}</PrivateRouteCMS>;
};
